import React, { useState } from "react";
import "../css/MyWallet.css"; // Include the CSS file
import NavbarComponent from "./Navbar";
import FooterComponent from "./Footer";
const MyWallet = () => {
  const [walletBalance, setWalletBalance] = useState(0); // Example balance
  const [transactions, setTransactions] = useState([
    { id: 1, type: "Added", amount: 2000, date: "2024-12-30" },
    { id: 2, type: "Withdrawn", amount: 1500, date: "2024-12-29" },
    { id: 3, type: "Added", amount: 3000, date: "2024-12-28" },
  ]);

  const handleAddFunds = () => {
    const amount = prompt("Enter the amount to add:");
    if (amount && !isNaN(amount)) {
      const newBalance = walletBalance + parseFloat(amount);
      setWalletBalance(newBalance);
      setTransactions([
        ...transactions,
        { id: transactions.length + 1, type: "Added", amount, date: new Date().toLocaleString() },
      ]);
    }
  };

  const handleWithdrawFunds = () => {
    const amount = prompt("Enter the amount to withdraw:");
    if (amount && !isNaN(amount)) {
      if (parseFloat(amount) > walletBalance) {
        alert("Insufficient balance!");
      } else {
        const newBalance = walletBalance - parseFloat(amount);
        setWalletBalance(newBalance);
        setTransactions([
          ...transactions,
          { id: transactions.length + 1, type: "Withdrawn", amount, date: new Date().toLocaleString() },
        ]);
      }
    }
  };

  return (
    <>
    <NavbarComponent/>
  
    <div className="wallet-container">
      <h1 className="wallet-header">My Wallet</h1>
      <div className="wallet-balance-card">
        <h2>Wallet Balance</h2>
        <p className="wallet-balance">₹ {walletBalance}</p>
        <div className="wallet-actions">
          <button onClick={handleAddFunds} className="wallet-button add-button">Add Funds</button>
          <button onClick={handleWithdrawFunds} className="wallet-button withdraw-button">Withdraw</button>
        </div>
      </div>
      <div className="transaction-history">
        <h2>Recent Transactions</h2>
        <ul>
          {transactions.map((txn) => (
            <li key={txn.id} className={`transaction-item ${txn.type.toLowerCase()}`}>
              <span>{txn.type} ₹{txn.amount}</span>
              <span>{txn.date}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <FooterComponent/>
    </>
  );
};

export default MyWallet;
